import { clsx } from 'clsx';

import { getInputGrid } from 'libs/utils/src/lib/helpers/getInputGrid';
import { formInputsDict } from '@monoimin/intl';

import { AnimatedLabel } from '@monoimin/atoms';

import type { InputProps } from '@monoimin/forms/gravity-form/types';

export const TextAreaInput = ({
  label,
  id,
  adminLabel,
  isRequired,
  value,
  locale,
  customId,
  layoutGridColumnSpan = 12,
  withPlaceholder,
  placeholder,
  classNames,
  labelPlacement,
  onChange,
}: InputProps) => {
  const valueLength = value?.length || 0;
  const isLabelInside = labelPlacement === 'hidden_label';

  const gridColumn = getInputGrid(layoutGridColumnSpan);
  return (
    <div
      className={clsx(
        'text-area-input flex flex-col relative group',
        classNames?.input,
        gridColumn
      )}
    >
      <div className='relative w-full'>
        {!withPlaceholder && !isLabelInside && (
          <label
            className='text-area-label body mb-2 block'
            htmlFor={String(id)}
          >
            {label}
          </label>
        )}
        <textarea
          onChange={onChange}
          id={customId}
          name={adminLabel || customId}
          className={clsx(
            'text-area-input-control bg-white peer w-full text-xl focus:outline-hidden pt-7 px-2 lg:px-3.5 pb-3.5 max-h-[200px] lg:max-h-[250px] border border-line',
            classNames?.inputTag
          )}
          rows={10}
          required={isRequired}
          maxLength={500}
          placeholder={withPlaceholder ? placeholder : undefined}
        />
        {!withPlaceholder && isLabelInside && (
          <AnimatedLabel inputValue={value} id={id}>
            {label}
          </AnimatedLabel>
        )}
      </div>

      <div className='text-area-input-limit text-xs text-shadowy-500 py-2'>
        {valueLength} {formInputsDict[locale]['characters']} |{' '}
        {500 - valueLength} {formInputsDict[locale]['charactersLeft']}
      </div>
    </div>
  );
};
